import { TEXAS_ELAR_2E_ACTIONS } from 'app/store/actions/media/ebooks.actions'
import baseRequestReducer from 'app/store/reducers/base-request.reducer'
import { EBooksInitialState } from 'app/types/ebooks-reducers.types'

const initialState: EBooksInitialState = {
  data: [],
  loading: true,
  error: false,
}

const TexasElar2E = baseRequestReducer(initialState, TEXAS_ELAR_2E_ACTIONS)

export default TexasElar2E
